export default "__VITE_ASSET__DCWORkej__"